module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel-add",
    attrs: {
      "datas": _vm.connects,
      "items": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitAddForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Add Team Member")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-839a1804"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/team-add-member.vue
// module id = 597
// module chunks = 4 5 6